const STORAGE_KEY_PREFIX = '__ss_';

export function setSecret(key, value) {
  if (value == null) {
    sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
    return;
  }
  sessionStorage.setItem(STORAGE_KEY_PREFIX + key, String(value));
}

export function getSecret(key) {
  const raw = sessionStorage.getItem(STORAGE_KEY_PREFIX + key);
  return raw !== null ? raw : null;
}

export function removeSecret(key) {
  sessionStorage.removeItem(STORAGE_KEY_PREFIX + key);
}
